import React from 'react';
import { ValidationMessage } from './validation-message';
import { FormHelperText } from '@dropbox/dig-components/form_row';
import { FormattedMessage } from 'react-intl';

interface Props {
  id: string;
  required: boolean;
  isDateField?: boolean;
  errorMessage?: string;
}

export function FieldHelperText({
  id,
  required,
  isDateField,
  errorMessage,
}: Props) {
  if (errorMessage) {
    return <ValidationMessage message={errorMessage} id={`validation_${id}`} />;
  }

  if (isDateField) {
    return (
      <FormHelperText variant="default" id={`validation_${id}`}>
        <FormattedMessage
          id="e481d18a0ea16e3c1bb84292b959a878eb410842423154b9ef18e6d04020ac12"
          defaultMessage="Signing date auto-filled and not editable"
          description="Message indicating a date field is auto-filled with the signing date"
        />
      </FormHelperText>
    );
  }

  return (
    <FormHelperText variant="default" id={`validation_${id}`}>
      <>
        {required ? (
          <FormattedMessage
            id="c1ccc687d4f3320c7cd2164dd234fce19dff0c45f1cf690e2f3107694a824a99"
            defaultMessage="Required field."
            description="Drawer header message indicating a required field"
          />
        ) : (
          <FormattedMessage
            id="597cfb067a7a2337668c3920fd75014079a39f5fa60c4ac3462c759ec90d6db1"
            defaultMessage="Optional field."
            description="Drawer header message indicating an optional field"
          />
        )}
      </>
    </FormHelperText>
  );
}
